<div
  class="flex flex-col bg-no-repeat bg-cover bg-center px-2 py-2 md:py-4 md:px-8 lg:px-12 lg:py-4"
  style="background-image: url('/assets/images/body.webp');">
  <div class="w-full flex justify-center mb-4 mt-8 md:mt-12 lg:mt-0 order-2 lg:order-1">
    <app-top-navbar class="w-full max-w-8xl"></app-top-navbar>
  </div>

  <div class="w-full flex justify-center mb-6 order-1 lg:order-2">
    <app-navbar class="w-full max-w-8xl"></app-navbar>
  </div>
  <div class="w-full max-w-6xl mx-auto order-3 flex flex-col gap-2">
    @if (getOrderTypeLabel() && getFormattedLocation().text) {
      <div class="flex items-center justify-center h-auto">
        <div class="address-pill">
          <div class="type-section">
            <p class="type-text"
            [class.text-primary]="isMilano" [class.text-base]="!isMilano">{{ getOrderTypeLabel() }}</p>
            @if (isDelivery) {
              <p class="delay-text">Délai : {{ formatDeliveryDelay() }}</p>
            }
          </div>
          <div class="location-section"
          [class.bg-primary]="isMilano" [class.bg-secondary/20]="!isMilano">
            <div class="location-info">
              <p class="location-address">{{ getFormattedLocation().text }}</p>
              @if (getMinOrderAmount()) {
                <p class="min-amount">{{ getMinOrderAmount() }}</p>
              }
            </div>
            <button (click)="openDialog()" class="edit-action">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }
    <span class="font-normal text-[18px] text-center md:text-[28px] text-[#FFFFFF] text">Commandez vos plats préférés en quelques clics ! 😋</span>

  </div>
</div>

<div class="py-4 px-4 md:px-8 lg:px-12">
  @if (isLoading()) {
    <div class="flex justify-center items-center min-h-[400px]">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
      <span
        class="ml-2 text-gray-600">Chargement en cours
      ...</span>
    </div>
  }
  @if (bundle && !isLoading()) {
    <div>
      <div class="md:hidden space-y-6">
        <div class=" rounded-lg  bg-base-200 content-image p-4">
          <div class="flex items-center gap-4">
           <div class="relative w-[40%] aspect-square flex items-center justify-center">
  <img
    [ngSrc]="bundle.image || 'assets/images/placeholders/placeholder.webp'"
    [alt]="bundle.name || 'Image à venir'"
    fill
    loading="lazy"
    sizes="(max-width: 768px) 40vw, 30vw"
    class="object-contain rounded-lg"
  />
</div>
              <div class="">
                <div>
                  <h1 class="text-primary text-2xl font-semibold mb-2">{{bundle.name}}
                  </h1>
                </div>
                <p class="text-xl font-bold mb-2">{{ formatBundlePrice() }}</p>
              </div>
            </div>
            <p class="text-site text-sm leading-relaxed text-center">{{bundle.description}}</p>
          </div>
          <ng-template #ruleTemplateMobile let-rules="rules" let-level="level">
            @for (rule of rules; track rule; let ruleIndex = $index) {
              <!-- ========================================= -->
              <!-- CAS 1 : OR avec NESTED RULES (choix groupe) -->
              <!-- ========================================= -->
              @if (rule.type === 'OR' && rule.nestedRules?.length) {
                <div
                  [id]="'mobile-rule-' + rule.id"
                  class="mb-6 p-2 bg-orange-50 rounded-lg border-2 "
                  style="background-color: var(--card-bg); border-color: var(--border-color);"
                  [style.margin-left.px]="level * 2">
                  <h3 class="text-lg font-bold text-site mb-1">
                    🔀 {{ rule.name }}
                  </h3>
                  <p class="text-sm text-gray-600 mb-4">
                    Sélectionnez {{ rule.minSelections }}
                    {{ rule.minSelections > 1 ? 'options' : 'option' }}
                    ({{ getOrGroupSelectionCount(rule.id) }}/{{ rule.maxSelections }})
                  </p>
                  <!-- LISTE DES GROUPES OR -->
                  <div class="grid gap-3">
                    @for (nestedRule of rule.nestedRules; track nestedRule) {
                      <div
                        class="rounded-lg border-2 transition-all"
                        [class.border-secondary]="isOrGroupSelected(rule.id, nestedRule.id)"
                        [class.bg-white]="isOrGroupSelected(rule.id, nestedRule.id)"
                        [class.border-gray-300]="!isOrGroupSelected(rule.id, nestedRule.id)"
                        [class.bg-field]="!isOrGroupSelected(rule.id, nestedRule.id)">
                        <!-- HEADER (NOM + CHECK) -->
                        <button
                          type="button"
                          (click)="toggleOrGroup(rule.id, nestedRule.id, rule)"
                          class="w-full p-4 flex items-center justify-between text-left">
                          <div>
                            <h5 class="font-semibold text-site">
                              {{ nestedRule.name }}
                            </h5>
                            <p class="text-xs text-gray-500">
                              {{ nestedRule.components?.length || 0 }} produit(s)
                            </p>
                          </div>
                          <div>
                            @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                              <div
                                class="w-6 h-6 rounded-full bg-secondary flex items-center justify-center">
                                <mat-icon class="text-white text-sm">check</mat-icon>
                              </div>
                            }
                            @if (!isOrGroupSelected(rule.id, nestedRule.id)) {
                              <div
                              class="w-6 h-6 rounded-full border-2 border-gray-400"></div>
                            }
                          </div>
                        </button>
                        <!-- CONTENU DANS LE MEME DIV -->
                        @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                          <div
                            class="px-2 pb-4 pt-2 border-t border-gray-300">
                            <ng-container
                    *ngTemplateOutlet="ruleTemplateMobile;
              context: { rules: [nestedRule], level: level + 1 }">
                            </ng-container>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- ========================================= -->
              <!-- CAS 2 : OR SIMPLE (composants directs) -->
              <!-- ========================================= -->
              @if (rule.type === 'OR' && (!rule.nestedRules || !rule.nestedRules.length)) {
                <div
                  [id]="'mobile-rule-' + rule.id"
                  class="mb-6 p-2 rounded-lg border-2 "
                  style="background-color: var(--card-bg); border-color: var(--border-color);"
                  [style.margin-left.px]="level * 2">
                  <h3 class="text-lg font-semibold text-orange-600 mb-1">
                    🔀 {{ rule.name }}
                  </h3>
                  <p class="text-sm text-gray-600 mb-4">
                    {{ getRuleSelectionInfo(rule) }}
                  </p>
                  @for (component of rule.components; track component) {
                    <div class="mb-6">
                      <h4 class="text-[20px] text-site font-semibold mb-3"
                        [id]="'mobile-component-' + component.id">
                        {{ component.category.name }}
                        @if (component.size) {
                          <span> - {{ component.size.name }}</span>
                        }
                        <span class="text-[16px] font-normal text-gray-400">
                          ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                          - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                        </span>
                      </h4>
                      <div class="grid 2xl:grid-cols-2 gap-3">
                        @for (item of component.availableItems; track item) {
                          <div
                            [attr.data-component]="component.id"
                            [attr.data-item]="item.id"
                            class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                            [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                            [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                            [class.opacity-60]="item.available === false"
                            [class.cursor-not-allowed]="item.available === false"
                            [class.cursor-pointer]="item.available === true">
                            <!-- Badge Non disponible -->
                            @if (item.available === false) {
                              <span
                                class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                Non disponible
                              </span>
                            }
                            <div class="flex items-center space-x-3 flex-1 min-w-0">
                              <div class="flex-1 min-w-0">
                                <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                              </div>
                            </div>
                            <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                              <button (click)="decrementItem(component.id, item.id)"
                                [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                -
                              </button>
                              <span class="font-bold">
                                {{ getItemQuantity(component.id, item.id) }}
                              </span>
                              <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                [disabled]="item.available === false"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                +
                              </button>
                            </div>
                            @if (item.image) {
                        <img
                          [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                          [alt]="item.name || 'Image à venir'"
                          width="50"
                          height="50"
                          loading="lazy"
                          class=" object-cover rounded-lg flex-shrink-0">
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- ========================================= -->
              <!-- CAS 3 : AND -->
              <!-- ========================================= -->
              @if (rule.type === 'AND') {
                <div
                  [id]="'mobile-rule-' + rule.id"
                  class="mb-6 p-2 rounded-lg border-l-4 border-gray-400 content-menu"
                  [style.margin-left.px]="level * 2">
                  @if (rule.name) {
                    <h3 class="text-[18px] font-semibold text-site mb-1">
                      ✓ {{ rule.name }}
                    </h3>
                  }
                  <p class="text-sm text-gray-600 mb-4">
                    {{ getRuleSelectionInfo(rule) }}
                  </p>
                  @for (component of rule.components; track component) {
                    <div class="mb-6">
                      <h4 class="text-[20px] text-site font-semibold mb-3"
                        [id]="'mobile-component-' + component.id">
                        {{ component.category.name }}
                        @if (component.size) {
                          <span> - {{ component.size.name }}</span>
                        }
                        <span class="text-[16px] font-normal text-gray-400">
                          ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                          - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                        </span>
                      </h4>
                      <div class="grid 2xl:grid-cols-2 gap-3">
                        @for (item of component.availableItems; track item) {
                          <div
                            [attr.data-component]="component.id"
                            [attr.data-item]="item.id"
                            class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                            [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                            [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                            [class.opacity-60]="item.available === false"
                            [class.cursor-not-allowed]="item.available === false"
                            [class.cursor-pointer]="item.available === true">
                            <!-- Badge Non disponible -->
                            @if (item.available === false) {
                              <span
                                class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                Non disponible
                              </span>
                            }
                            <div class="flex items-center space-x-3 flex-1 min-w-0">
                              <div class="flex-1 min-w-0">
                                <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                              </div>
                            </div>
                            <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                              <button (click)="decrementItem(component.id, item.id)"
                                [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                -
                              </button>
                              <span class="font-bold">
                                {{ getItemQuantity(component.id, item.id) }}
                              </span>
                              <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                [disabled]="item.available === false"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                +
                              </button>
                            </div>
                            @if (item.image) {
                        <img
                          [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                          [alt]="item.name || 'Image à venir'"
                          width="50"
                          height="50"
                          loading="lazy"
                          class="object-cover rounded-lg flex-shrink-0">
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- RECURSIVITÉ -->
                  @if (rule.nestedRules?.length) {
                    <ng-container
                *ngTemplateOutlet="ruleTemplateMobile;
          context: { rules: rule.nestedRules, level: level + 1 }">
                    </ng-container>
                  }
                </div>
              }
            }
          </ng-template>
          <div class="space-y-6">
            <h2 class="text-[24px] text-[#FF730A] title  mb-3 ">
              Choisissez votre menu
            </h2>
            <ng-container *ngTemplateOutlet="ruleTemplateMobile; context: {rules: processedRules, level: 0}"></ng-container>
          </div>
      <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t
      mx-[16px] shadow-lg p-2 z-50">
            @if (!canAddToCart()) {
              <p
                class="text-[#FF730A] text-xs text-center mb-1 font-medium">
                {{ getValidationMessage() }}
              </p>
            }
            <div class="flex items-center justify-center">
              <button
                (click)="toggleCartSheet()"
                [disabled]="!canAddToCart()"
                [class.disabled]="!canAddToCart()"
                class="add  px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
                <span>Voir détails</span>
              </button>
            </div>
          </div>
          @if (isCartSheetOpen) {
            <div
              class="fixed inset-0 z-[60]">
              <!-- Fond noir semi-transparent -->
              <div
                class="absolute inset-0 bg-neutral transition-opacity duration-300"
                [class.opacity-50]="isCartSheetOpen"
                [class.opacity-0]="!isCartSheetOpen"
                (click)="toggleCartSheet()">
              </div>
              <div
                class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col"
                [style.transform]="sheetTransform"
                >
                <div class="flex justify-end pr-3 pt-3">
                  <mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
                </div>
                <!-- === CONTENU DU PANIER === -->
                <div class="flex justify-center items-center p-3">
                  <p class="font-semibold text-[#FF730A] title text-[25px]">{{bundle.name}}</p>
                </div>
                <div class="flex-1 overflow-y-auto px-4 py-2 space-y-4" #scrollableContent>
                  <div class=" rounded-[6px] ">
                    <div class="mb-4">
                      @if (getSelectedItems().length > 0) {
                        <div class="bg-base-300 rounded-[6px] p-[12px]"
                          >
                          @for (selectedItem of getSelectedItems(); track trackItem(selectedItem.id, $index)) {
                            <div
                              class="text-sm text-site mb-3 pb-3 border-b border-gray-100 last:border-b-0 last:mb-0 last:pb-0">
                              @for (i of [].constructor(selectedItem.quantity); track i; let index = $index) {
                                <div class="flex justify-between items-start mb-1">
                                  <div class="flex-1">
                                    <div class="flex items-center flex-wrap gap-1">
                                      <span class="text-base text-site font-medium">{{ selectedItem.name }}</span>
                                      @if (getComponentById(selectedItem.componentId)?.size) {
                                        <span
                                          class="text-gray-500 text-xs">
                                          ({{ getSizeText(getComponentById(selectedItem.componentId)) }})
                                        </span>
                                      }
                                      @if (selectedItem.quantity > 1) {
                                        <span class="text-gray-500 text-xs">
                                          #{{ index + 1 }}
                                        </span>
                                      }
                                    </div>
                                    <!-- Bouton Personnaliser -->
                                    @if (customizableItems[selectedItem.id]) {
                                      <div class="mt-1">
                                        <span
                                          (click)="openProductCustomization(selectedItem, selectedItem.componentId, index); $event.stopPropagation()"
                                          class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors underline"
                                          [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)"
                                          [class.text-red-600]="hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)">
                                          @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) || hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                            <mat-icon
                                              class="material-symbols-outlined text-sm mr-1">
                                              {{ hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'warning' : '' }}
                                            </mat-icon>
                                          }
                                          {{ isItemCustomized(selectedItem.componentId, selectedItem.id, index) ?
                                          (hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'Compléter' : 'Modifier') :
                                          'Personnaliser' }}
                                        </span>
                                      </div>
                                    }
                                  </div>
                                  <!-- Bouton Supprimer -->
                                  <mat-icon
                                    class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                                    (click)="removeItem(selectedItem.componentId, selectedItem.id)"
                                    title="Supprimer">
                                    delete
                                  </mat-icon>
                                </div>
                                <!-- Résumé personnalisation -->
                                @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) && !hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                  <div
                                    class="mt-2 ml-1 space-y-1">
                                    <div class=" rounded-md px-2 py-1.5 text-xs">
                                      <div class="text-gray-400 leading-relaxed">
                                        @for (line of getCustomizationSummary(selectedItem.componentId, selectedItem.id, index).split('\n'); track line) {
                                          <div
                                            >
                                            @if (line.startsWith('➕ Suppléments')) {
                                              <span>{{ line.split(':')[0] }} : </span>
                                              @for (part of line.split(':')[1].split('|||'); track part; let last = $last) {
                                                @if (part.includes('[CAT]')) {
                                                  <span class="text-primary font-semibold">
                                                    {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                                                  </span>
                                                  - {{ part.split('-').slice(1).join('-') }}
                                                } @else {
                                                  {{ part }}
                                                }
                                                @if (!last) {
                                                  <span>, </span>
                                                }
                                              }
                                            } @else {
                                              {{ line }}
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                      <!-- Message si panier vide -->
                      @if (getSelectedItems().length === 0) {
                        <div
                          class="text-center text-gray-400 text-sm py-4">
                          Aucun article sélectionné
                        </div>
                      }
                      <!-- Message de validation -->
                    </div>
                    <!-- Prix total -->
                  </div>
                </div>
                <div class="border-t border-gray-200 p-4 bg-base-200 flex flex-col gap-3" #scrollableContent>
                  @if (getSelectedItems().length > 0) {
                    <div>
                      <div class="flex justify-between items-center">
                        <span class="text-sm text-site">Prix de base</span>
                        <span class="text-sm font-semibold text-site">
                  {{ formatBundlePrice() }}
                        </span>
                      </div>
                      @if (getTotalCartPrice() > bundle.price || isRedeemMode) {
                  <div class="mt-2 space-y-1">
                    @if (getExtrasPrice() > 0) {
                    <div class="flex justify-between items-center text-xs text-gray-500">
                      <span>Suppléments</span>
                      <span class="text-green-600">+{{ getExtrasPrice().toFixed(2) }} €</span>
      </div>
                    }
                    <div class="flex justify-between items-center pt-2 border-t border-gray-200">
                      <span class="text-base font-bold text-site">Total</span>
                      <span class="text-base font-bold text-site">
        {{ formatBundleTotal() }}
      </span>
                    </div>
                  </div>
                  }
                    </div>
                  }
                  <!-- Bouton Ajouter au panier -->
                  <button
                    [matButton]="themeConfig.appearance.button.action"
                    [disabled]="!canAddToCart() || isSubmitting()"
                    class="w-full py-2 "
                    (click)="addToCart()"
                    >
                    <span>Ajouter au panier</span>
                  </button>
                  @if (getValidationMessage() !== '') {
                    <div
                      class=" p-3 rounded-[6px]">
                      <div class="text-sm text-red-500 flex items-center">
                        <div>
                          <mat-icon class="material-symbols-outlined text-sm mr-1 text-[18px]">warning</mat-icon>
                        </div>
                        <span>
                          {{ getValidationMessage() }}
                        </span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <div class="hidden md:flex xl:hidden gap-4">
          <div class="w-1/3 flex-shrink-0">
            <div class="sticky top-4">
              <div class="relative w-full aspect-square flex items-center justify-center mb-4">
  <img
    [ngSrc]="bundle.image || 'assets/images/placeholders/placeholder.webp'"
    [alt]="bundle.name || 'Image à venir'"
    fill
    loading="lazy"
    sizes="(max-width: 768px) 100vw, 50vw"
    class="object-contain rounded-lg label"
  />
</div>
                <h1 class="text-primary text-2xl font-semibold mb-2">{{bundle.name}}
                </h1>
                <p class="text-xl font-bold mb-2">{{ formatBundlePrice() }}</p>
                <p class="text-site text-sm leading-relaxed">{{bundle.description}}</p>
              </div>
            </div>
            <ng-template #ruleTemplateTablet let-rules="rules" let-level="level">
              @for (rule of rules; track rule; let ruleIndex = $index) {
                <!-- ========================================= -->
                <!-- CAS 1 : OR avec NESTED RULES (choix groupe) -->
                <!-- ========================================= -->
                @if (rule.type === 'OR' && rule.nestedRules?.length) {
                  <div
                    [id]="'tablet-rule-' + rule.id"
                    class="mb-6 p-2 rounded-lg border-2 "
                    style="background-color: var(--card-bg); border-color: var(--border-color);"
                    [style.margin-left.px]="level * 5">
                    <h3 class="text-lg font-bold text-site mb-1">
                      🔀 {{ rule.name }}
                    </h3>
                    <p class="text-sm text-gray-600 mb-4">
                      Sélectionnez {{ rule.minSelections }}
                      {{ rule.minSelections > 1 ? 'options' : 'option' }}
                      ({{ getOrGroupSelectionCount(rule.id) }}/{{ rule.maxSelections }})
                    </p>
                    <!-- LISTE DES GROUPES OR -->
                    <div class="grid gap-3">
                      @for (nestedRule of rule.nestedRules; track nestedRule) {
                        <div
                          class="rounded-lg border-2 transition-all"
                          [class.border-secondary]="isOrGroupSelected(rule.id, nestedRule.id)"
                          [class.bg-white]="isOrGroupSelected(rule.id, nestedRule.id)"
                          [class.border-gray-300]="!isOrGroupSelected(rule.id, nestedRule.id)"
                          [class.bg-field]="!isOrGroupSelected(rule.id, nestedRule.id)">
                          <!-- HEADER (NOM + CHECK) -->
                          <button
                            type="button"
                            (click)="toggleOrGroup(rule.id, nestedRule.id, rule)"
                            class="w-full p-4 flex items-center justify-between text-left">
                            <div>
                              <h5 class="font-semibold text-site">
                                {{ nestedRule.name }}
                              </h5>
                              <p class="text-xs text-gray-500">
                                {{ nestedRule.components?.length || 0 }} produit(s)
                              </p>
                            </div>
                            <div>
                              @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                                <div
                                  class="w-6 h-6 rounded-full bg-secondary flex items-center justify-center">
                                  <mat-icon class="text-white text-sm">check</mat-icon>
                                </div>
                              }
                              @if (!isOrGroupSelected(rule.id, nestedRule.id)) {
                                <div
                                class="w-6 h-6 rounded-full border-2 border-gray-400"></div>
                              }
                            </div>
                          </button>
                          <!-- CONTENU DANS LE MEME DIV -->
                          @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                            <div
                              class="px-2 pb-4 pt-2 border-t border-gray-300">
                              <ng-container
                    *ngTemplateOutlet="ruleTemplateTablet;
              context: { rules: [nestedRule], level: level + 1 }">
                              </ng-container>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- ========================================= -->
                <!-- CAS 2 : OR SIMPLE (composants directs) -->
                <!-- ========================================= -->
                @if (rule.type === 'OR' && (!rule.nestedRules || !rule.nestedRules.length)) {
                  <div
                    [id]="'tablet-rule-' + rule.id"
                    class="mb-6 p-2 rounded-lg border-2 "
                    style="background-color: var(--card-bg); border-color: var(--border-color);"
                    [style.margin-left.px]="level * 5">
                    <h3 class="text-lg font-semibold text-orange-600 mb-1">
                      🔀 {{ rule.name }}
                    </h3>
                    <p class="text-sm text-gray-600 mb-4">
                      {{ getRuleSelectionInfo(rule) }}
                    </p>
                    @for (component of rule.components; track component) {
                      <div class="mb-6">
                        <h4 class="text-[20px] text-site font-semibold mb-3"
                          [id]="'tablet-component-' + component.id"
                          >
                          {{ component.category.name }}
                          @if (component.size) {
                            <span> - {{ component.size.name }}</span>
                          }
                          <span class="text-[16px] font-normal text-gray-400">
                            ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                            - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                          </span>
                        </h4>
                        <div class="grid 2xl:grid-cols-2 gap-3">
                          @for (item of component.availableItems; track item) {
                            <div
                              [attr.data-component]="component.id"
                              [attr.data-item]="item.id"
                              class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                              [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                              [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                              [class.opacity-60]="item.available === false"
                              [class.cursor-not-allowed]="item.available === false"
                              [class.cursor-pointer]="item.available === true">
                              <!-- Badge Non disponible -->
                              @if (item.available === false) {
                                <span
                                  class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                  Non disponible
                                </span>
                              }
                              <div class="flex items-center space-x-3 flex-1 min-w-0">
                                <div class="flex-1 min-w-0">
                                  <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                                <button (click)="decrementItem(component.id, item.id)"
                                  [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                  -
                                </button>
                                <span class="font-bold">
                                  {{ getItemQuantity(component.id, item.id) }}
                                </span>
                                <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                  [disabled]="item.available === false"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                  +
                                </button>
                              </div>
                              @if (item.image) {
                          <img
                            [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                            [alt]="item.name || 'Image à venir'"
                            width="50"
                            height="50"
                            loading="lazy"
                            class=" object-cover rounded-lg flex-shrink-0">
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }
                <!-- ========================================= -->
                <!-- CAS 3 : AND -->
                <!-- ========================================= -->
                @if (rule.type === 'AND') {
                  <div
                    [id]="'tablet-rule-' + rule.id"
                    class="mb-6 p-2 rounded-lg border-l-4 border-gray-400 content-menu "
                    [style.margin-left.px]="level * 5">
                    @if (rule.name) {
                      <h3 class="text-[18px] font-semibold text-site mb-1">
                        ✓ {{ rule.name }}
                      </h3>
                    }
                    <p class="text-sm text-gray-600 mb-4">
                      {{ getRuleSelectionInfo(rule) }}
                    </p>
                    @for (component of rule.components; track component) {
                      <div class="mb-6">
                        <h4 class="text-[20px] text-site font-semibold mb-3"
                          [id]="'tablet-component-' + component.id">
                          {{ component.category.name }}
                          @if (component.size) {
                            <span> - {{ component.size.name }}</span>
                          }
                          <span class="text-[16px] font-normal text-gray-400">
                            ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                            - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                          </span>
                        </h4>
                        <div class="grid 2xl:grid-cols-2 gap-3">
                          @for (item of component.availableItems; track item) {
                            <div
                              [attr.data-component]="component.id"
                              [attr.data-item]="item.id"
                              class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                              [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                              [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                              [class.opacity-60]="item.available === false"
                              [class.cursor-not-allowed]="item.available === false"
                              [class.cursor-pointer]="item.available === true">
                              <!-- Badge Non disponible -->
                              @if (item.available === false) {
                                <span
                                  class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                  Non disponible
                                </span>
                              }
                              <div class="flex items-center space-x-3 flex-1 min-w-0">
                                <div class="flex-1 min-w-0">
                                  <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                                </div>
                              </div>
                              <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                                <button (click)="decrementItem(component.id, item.id)"
                                  [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                  -
                                </button>
                                <span class="font-bold">
                                  {{ getItemQuantity(component.id, item.id) }}
                                </span>
                                <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                  [disabled]="item.available === false"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                  +
                                </button>
                              </div>
                              @if (item.image) {
                          <img
                            [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                            [alt]="item.name || 'Image à venir'"
                            width="50"
                            height="50"
                            loading="lazy"
                            class="object-cover rounded-lg flex-shrink-0">
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <!-- RECURSIVITÉ -->
                    @if (rule.nestedRules?.length) {
                      <ng-container
                *ngTemplateOutlet="ruleTemplateTablet;
          context: { rules: rule.nestedRules, level: level + 1 }">
                      </ng-container>
                    }
                  </div>
                }
              }
            </ng-template>
            <div class="flex-1 overflow-y-auto pr-4">
              <div class="space-y-6">
                <h2 class="text-[24px] text-[#FF730A] title mb-3 ">
                  Choisissez votre menu
                </h2>
                <ng-container
                *ngTemplateOutlet="ruleTemplateTablet; context: {rules: processedRules, level: 0}"></ng-container>
              </div>
            </div>
      <div class="fixed bottom-0 left-0 right-0 bg-[#2B150575] backdrop-blur-md border-b border-orange-900/30 border-t
      mx-[16px] shadow-lg p-2 z-50">
              @if (!canAddToCart()) {
                <p
                  class="text-[#FF730A] text-xs text-center mb-1 font-medium">
                  {{ getValidationMessage() }}
                </p>
              }
              <div class="flex items-center justify-center">
                <button
                  (click)="toggleCartSheet()"
                  [disabled]="!canAddToCart()"
                  [class.disabled]="!canAddToCart()"
                  class=" add  px-6 py-3 rounded-lg font-semibold flex items-center gap-2 w-full justify-center">
                  <span>Voir détails</span>
                </button>
              </div>
            </div>
            @if (isCartSheetOpen) {
              <div
                class="fixed inset-0 z-[60]">
                <!-- Fond noir semi-transparent -->
                <div
                  class="absolute inset-0 bg-neutral transition-opacity duration-300"
                  [class.opacity-50]="isCartSheetOpen"
                  [class.opacity-0]="!isCartSheetOpen"
                  (click)="toggleCartSheet()">
                </div>
                <div
                  class="absolute bottom-0 left-0 right-0 bg-base-200 rounded-t-2xl shadow-2xl max-h-[85vh] flex flex-col"
                  [style.transform]="sheetTransform"
                  >
                  <div class="flex justify-end pr-3 pt-3">
                    <mat-icon class="text-gray-300 cursor-pointer" (click)="toggleCartSheet()">close</mat-icon>
                  </div>
                  <!-- === CONTENU DU PANIER === -->
                  <div class="flex justify-center items-center p-3">
                    <p class="font-semibold text-[#FF730A] title text-[25px]">{{bundle.name}}</p>
                  </div>
                  <div class="flex-1 overflow-y-auto px-4 py-2 space-y-4" #scrollableContent>
                    <div class="rounded-[6px]">
                      <div class="mb-4">
                        @if (getSelectedItems().length > 0) {
                          <div class="bg-base-300 rounded-[6px] p-[12px]"
                            >
                            @for (selectedItem of getSelectedItems(); track trackItem(selectedItem.id, $index)) {
                              <div
                                class="text-sm text-site mb-3 pb-3 border-b border-gray-100 last:border-b-0 last:mb-0 last:pb-0">
                                @for (i of [].constructor(selectedItem.quantity); track i; let index = $index) {
                                  <div class="flex justify-between items-start mb-1">
                                    <div class="flex-1">
                                      <div class="flex items-center flex-wrap gap-1">
                                        <span class="text-base text-site font-medium">{{ selectedItem.name }}</span>
                                        @if (getComponentById(selectedItem.componentId)?.size) {
                                          <span
                                            class="text-gray-500 text-xs">
                                            ({{ getSizeText(getComponentById(selectedItem.componentId)) }})
                                          </span>
                                        }
                                        @if (selectedItem.quantity > 1) {
                                          <span class="text-gray-500 text-xs">
                                            #{{ index + 1 }}
                                          </span>
                                        }
                                      </div>
                                      <!-- Bouton Personnaliser -->
                                      @if (customizableItems[selectedItem.id]) {
                                        <div class="mt-1">
                                          <span
                                            (click)="openProductCustomization(selectedItem, selectedItem.componentId, index); $event.stopPropagation()"
                                            class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors underline"
                                            [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)"
                                            [class.text-red-600]="hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)">
                                            @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) || hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                              <mat-icon
                                                class="material-symbols-outlined text-sm mr-1">
                                                {{ hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'warning' : '' }}
                                              </mat-icon>
                                            }
                                            {{ isItemCustomized(selectedItem.componentId, selectedItem.id, index) ?
                                            (hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'Compléter' : 'Modifier') :
                                            'Personnaliser' }}
                                          </span>
                                        </div>
                                      }
                                    </div>
                                    <!-- Bouton Supprimer -->
                                    <mat-icon
                                      class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                                      (click)="removeItem(selectedItem.componentId, selectedItem.id)"
                                      title="Supprimer">
                                      delete
                                    </mat-icon>
                                  </div>
                                  <!-- Résumé personnalisation -->
                                  @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) && !hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                    <div
                                      class="mt-2 ml-1 space-y-1">
                                      <div class=" rounded-md px-2 py-1.5 text-xs">
                                        <div class="text-gray-400 leading-relaxed">
                                          @for (line of getCustomizationSummary(selectedItem.componentId, selectedItem.id, index).split('\n'); track line) {
                                            <div
                                              >
                                              @if (line.startsWith('➕ Suppléments')) {
                                                <span>{{ line.split(':')[0] }} : </span>
                                                @for (part of line.split(':')[1].split('|||'); track part; let last = $last) {
                                                  @if (part.includes('[CAT]')) {
                                                    <span class="text-primary font-semibold">
                                                      {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                                                    </span>
                                                    - {{ part.split('-').slice(1).join('-') }}
                                                  } @else {
                                                    {{ part }}
                                                  }
                                                  @if (!last) {
                                                    <span>, </span>
                                                  }
                                                }
                                              } @else {
                                                {{ line }}
                                              }
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                        <!-- Message si panier vide -->
                        @if (getSelectedItems().length === 0) {
                          <div
                            class="text-center text-gray-400 text-sm py-4">
                            Aucun article sélectionné
                          </div>
                        }
                        <!-- Message de validation -->
                      </div>
                      <!-- Prix total -->
                    </div>
                  </div>
                  <div class=" p-4 border-t border-gray-200 bg-base-200 flex flex-col gap-3" #scrollableContent>
                    @if (getSelectedItems().length > 0) {
                      <div>
                        <div class="flex justify-between items-center">
                          <span class="text-sm text-site">Prix de base</span>
                          <span class="text-sm font-semibold text-site">
                    {{ formatBundlePrice() }}
                          </span>
                        </div>
                        @if (getTotalCartPrice() > bundle.price || isRedeemMode) {
                    <div class="mt-2 space-y-1">
                      @if (getExtrasPrice() > 0) {
                      <div class="flex justify-between items-center text-xs text-gray-500">
                        <span>Suppléments</span>
                        <span class="text-green-600">+{{ getExtrasPrice().toFixed(2) }} €</span>
      </div>
                      }
                      <div class="flex justify-between items-center pt-2 border-t border-gray-200">
                        <span class="text-base font-bold text-site">Total</span>
                        <span class="text-base font-bold text-site">
        {{ formatBundleTotal() }}
      </span>
                      </div>
                    </div>
                    }
                      </div>
                    }
                    <!-- Bouton Ajouter au panier -->
                    <button
                      [matButton]="themeConfig.appearance.button.action"
                      [disabled]="!canAddToCart() || isSubmitting()"
                      class="w-full py-2 "
                      (click)="addToCart()"
                      >
                      <span>Ajouter au panier</span>
                    </button>
                    @if (getValidationMessage() !== '') {
                      <div
                        class=" p-3 rounded-[6px]">
                        <div class="text-sm text-red-500 flex items-center">
                          <div>
                            <mat-icon class="material-symbols-outlined text-sm mr-1 text-[18px]">warning</mat-icon>
                          </div>
                          <span>
                            {{ getValidationMessage() }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="hidden xl:flex gap-4">
            <div class="w-1/4 flex-shrink-0">
  <div class="sticky top-4">
    <div class="relative w-full aspect-square flex items-center justify-center mb-4">
      <img
        [ngSrc]="bundle.image || 'assets/images/placeholders/placeholder.webp'"
        [alt]="bundle.name || 'Image à venir'"
        fill
        loading="lazy"
        sizes="25vw"
        class="object-contain rounded-lg label"
      />
    </div>
    <h1 class="text-primary text-2xl font-semibold mb-2">{{ bundle.name }}</h1>
    <p class="text-xl font-bold mb-2">{{ formatBundlePrice() }}</p>
    <p class="text-site text-sm leading-relaxed">{{ bundle.description }}</p>
  </div>
</div>
              <ng-template #ruleTemplate let-rules="rules" let-level="level">
                @for (rule of rules; track rule; let ruleIndex = $index) {
                  <!-- ========================================= -->
                  <!-- CAS 1 : OR avec NESTED RULES (choix groupe) -->
                  <!-- ========================================= -->
                  @if (rule.type === 'OR' && rule.nestedRules?.length) {
                    <div
                      [id]="'desktop-rule-' + rule.id"
                      class="mb-6 p-2 rounded-lg border-2 "
                      style="background-color: var(--card-bg); border-color: var(--border-color);"
                      [style.margin-left.px]="level * 5">
                      <h3 class="text-lg font-bold text-site mb-1">
                        🔀 {{ rule.name }}
                      </h3>
                      <p class="text-sm text-gray-600 mb-4">
                        Sélectionnez {{ rule.minSelections }}
                        {{ rule.minSelections > 1 ? 'options' : 'option' }}
                        ({{ getOrGroupSelectionCount(rule.id) }}/{{ rule.maxSelections }})
                      </p>
                      <!-- LISTE DES GROUPES OR -->
                      <div class="grid gap-3">
                        @for (nestedRule of rule.nestedRules; track nestedRule) {
                          <div
                            class="rounded-lg border-2 transition-all"
                            [class.border-secondary]="isOrGroupSelected(rule.id, nestedRule.id)"
                            [class.bg-white]="isOrGroupSelected(rule.id, nestedRule.id)"
                            [class.border-gray-300]="!isOrGroupSelected(rule.id, nestedRule.id)"
                            [class.bg-field]="!isOrGroupSelected(rule.id, nestedRule.id)">
                            <!-- HEADER (NOM + CHECK) -->
                            <button
                              type="button"
                              (click)="toggleOrGroup(rule.id, nestedRule.id, rule)"
                              class="w-full p-4 flex items-center justify-between text-left">
                              <div>
                                <h5 class="font-semibold text-site">
                                  {{ nestedRule.name }}
                                </h5>
                                <p class="text-xs text-gray-500">
                                  {{ nestedRule.components?.length || 0 }} produit(s)
                                </p>
                              </div>
                              <div>
                                @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                                  <div
                                    class="w-6 h-6 rounded-full bg-secondary flex items-center justify-center">
                                    <mat-icon class="text-white text-sm">check</mat-icon>
                                  </div>
                                }
                                @if (!isOrGroupSelected(rule.id, nestedRule.id)) {
                                  <div
                                  class="w-6 h-6 rounded-full border-2 border-gray-400"></div>
                                }
                              </div>
                            </button>
                            <!-- CONTENU DANS LE MEME DIV -->
                            @if (isOrGroupSelected(rule.id, nestedRule.id)) {
                              <div
                                class="px-2 pb-4 pt-2 border-t border-gray-300">
                                <ng-container
                    *ngTemplateOutlet="ruleTemplate;
              context: { rules: [nestedRule], level: level + 1 }">
                                </ng-container>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-- ========================================= -->
                  <!-- CAS 2 : OR SIMPLE (composants directs) -->
                  <!-- ========================================= -->
                  @if (rule.type === 'OR' && (!rule.nestedRules || !rule.nestedRules.length)) {
                    <div
                      [id]="'desktop-rule-' + rule.id"
                      class="mb-6 p-2 bg-orange-50 rounded-lg border-2"
                      style="background-color: var(--card-bg); border-color: var(--border-color);"
                      [style.margin-left.px]="level * 5">
                      <h3 class="text-lg font-semibold text-orange-600 mb-1">
                        🔀 {{ rule.name }}
                      </h3>
                      <p class="text-sm text-gray-600 mb-4">
                        {{ getRuleSelectionInfo(rule) }}
                      </p>
                      @for (component of rule.components; track component) {
                        <div class="mb-6">
                          <h4 class="text-[20px] text-site font-semibold mb-3"
                            [id]="'desktop-component-' + component.id">
                            {{ component.category.name }}
                            @if (component.size) {
                              <span> - {{ component.size.name }}</span>
                            }
                            <span class="text-[16px] font-normal text-gray-400">
                              ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                              - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                            </span>
                          </h4>
                          <div class="grid 2xl:grid-cols-2 gap-3">
                            @for (item of component.availableItems; track item) {
                              <div
                                [attr.data-component]="component.id"
                                [attr.data-item]="item.id"
                                class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                                [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                                [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                                [class.opacity-60]="item.available === false"
                                [class.cursor-not-allowed]="item.available === false"
                                [class.cursor-pointer]="item.available === true">
                                <!-- Badge Non disponible -->
                                @if (item.available === false) {
                                  <span
                                    class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                    Non disponible
                                  </span>
                                }
                                <div class="flex items-center space-x-3 flex-1 min-w-0">
                                  <div class="flex-1 min-w-0">
                                    <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                                  </div>
                                </div>
                                <div class="flex items-center gap-2 mr-2 ml-2">
                                  <button (click)="decrementItem(component.id, item.id)"
                                    [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                    -
                                  </button>
                                  <span class="font-bold">
                                    {{ getItemQuantity(component.id, item.id) }}
                                  </span>
                                  <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                    [disabled]="item.available === false"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                    +
                                  </button>
                                </div>
                                @if (item.image) {
                            <img
                              [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                              [alt]="item.name || 'Image à venir'"
                              width="50"
                              height="50"
                              loading="lazy"
                              class=" object-cover rounded-lg flex-shrink-0">
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <!-- ========================================= -->
                  <!-- CAS 3 : AND -->
                  <!-- ========================================= -->
                  @if (rule.type === 'AND') {
                    <div
                      [id]="'desktop-rule-' + rule.id"
                      class="mb-6 p-2 rounded-lg border-l-4 border-gray-400 content-menu "
                      [style.margin-left.px]="level * 5">
                      @if (rule.name) {
                        <h3 class="text-[18px] font-semibold text-site mb-1">
                          ✓ {{ rule.name }}
                        </h3>
                      }
                      <p class="text-sm text-gray-600 mb-4">
                        {{ getRuleSelectionInfo(rule) }}
                      </p>
                      @for (component of rule.components; track component) {
                        <div class="mb-6">
                          <h4 class="text-[20px] text-site font-semibold mb-3"
                            [id]="'desktop-component-' + component.id">
                            {{ component.category.name }}
                            @if (component.size) {
                              <span> - {{ component.size.name }}</span>
                            }
                            <span class="text-[16px] font-normal text-gray-400">
                              ({{ component.required ? 'Obligatoire' : 'Optionnel' }}
                              - {{ getTotalQuantityForComponent(component.id) }}/{{ component.quantity }} choix)
                            </span>
                          </h4>
                          <div class="grid 2xl:grid-cols-2 gap-3">
                            @for (item of component.availableItems; track item) {
                              <div
                                [attr.data-component]="component.id"
                                [attr.data-item]="item.id"
                                class="relative flex items-center justify-between px-[14px] bg-white border border-[#E7E7E7] label rounded-[6px] transition-all"
                                [class.border-orange-500]="getItemQuantity(component.id, item.id) > 0"
                                [class.bg-orange-50]="getItemQuantity(component.id, item.id) > 0"
                                [class.opacity-60]="item.available === false"
                                [class.cursor-not-allowed]="item.available === false"
                                [class.cursor-pointer]="item.available">
                                <!-- Badge Non disponible -->
                                @if (!item.available) {
                                  <span
                                    class="absolute top-2 right-2 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                                    Non disponible
                                  </span>
                                }
                                <div class="flex items-center space-x-3 flex-1 min-w-0">
                                  <div class="flex-1 min-w-0">
                                    <span class="text-[12px] text-site font-medium break-words">{{ item.name }}</span>
                                  </div>
                                </div>
                                <div class="flex items-center gap-2 flex-shrink-0 mr-3">
                                  <button (click)="decrementItem(component.id, item.id)"
                                    [disabled]="getItemQuantity(component.id, item.id) === 0"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                    -
                                  </button>
                                  <span class="font-bold">
                                    {{ getItemQuantity(component.id, item.id) }}
                                  </span>
                                  <button (click)="incrementItem(component.id, item.id, component.quantity, ruleIndex)"
                                    [disabled]="!item.available"
                            class="w-[25px] h-[25px] cursor-pointer rounded-full border border-gray-300 flex
                            hover:text-[#1a1a1a] items-center justify-center hover:bg-gray-100
                            disabled:opacity-50 disabled:cursor-not-allowed transition-all">
                                    +
                                  </button>
                                </div>
                                @if (item.image) {
                            <img
                              [ngSrc]="item.image || 'assets/images/placeholders/placeholder.webp'"
                              [alt]="item.name || 'Image à venir'"
                              width="50"
                              height="50"
                              loading="lazy"
                              class="object-cover rounded-lg flex-shrink-0">
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                      <!-- RECURSIVITÉ -->
                      @if (rule.nestedRules?.length) {
                        <ng-container
                *ngTemplateOutlet="ruleTemplate;
          context: { rules: rule.nestedRules, level: level + 1 }">
                        </ng-container>
                      }
                    </div>
                  }
                }
              </ng-template>
              <div class="flex-1 pr-4">
                <div class="space-y-6">
                  <h2 class="text-[24px] text-[#FF730A] title  mb-3">
                    Choisissez votre menu
                  </h2>
                  <ng-container *ngTemplateOutlet="ruleTemplate; context: {rules: processedRules, level: 0}"></ng-container>
                </div>
              </div>
              <div class="w-80 flex-shrink-0">
                <div
                  class="sticky top-4 content-shopping flex flex-col rounded-[10px] p-[8px] h-auto max-h-[60vh] card">
                  <div class="flex justify-center items-center">
                    <p class="font-semibold text-[#FF730A] title text-[22px] mb-3 ">{{bundle.name}}</p>
                  </div>
                  <!--          <p class="font-bold ml-2 text-[#FF730A]">{{truncate2(bundle.price)}} {{bundle.public}}</p>-->
                  <div class="flex flex-col flex-1  rounded-[6px] overflow-hidden">
                    <div class="flex-1 overflow-y-auto p-3">
                      <div class="space-y-3">
                        <!-- Liste des items sélectionnés avec personnalisations -->
                        @if (getSelectedItems().length > 0) {
                          <div class="bg-base-300  rounded-[6px] p-[12px]"
                            >
                            @for (selectedItem of getSelectedItems(); track trackItem(selectedItem.id, $index)) {
                              <div
                                class="text-sm text-site mb-3 pb-3 border-b border-gray-100 last:border-b-0 last:mb-0 last:pb-0">
                                @for (i of [].constructor(selectedItem.quantity); track i; let index = $index) {
                                  <div class="flex justify-between items-start mb-1">
                                    <div class="flex-1">
                                      <div class="flex items-center flex-wrap gap-1">
                                        <span class="text-base text-site font-medium">{{ selectedItem.name }}</span>
                                        @if (getComponentById(selectedItem.componentId)?.size) {
                                          <span
                                            class="text-gray-500 text-xs">
                                            ({{ getSizeText(getComponentById(selectedItem.componentId)) }})
                                          </span>
                                        }
                                        @if (selectedItem.quantity > 1) {
                                          <span class="text-gray-500 text-xs">
                                            #{{ index + 1 }}
                                          </span>
                                        }
                                      </div>
                                      <!-- Bouton Personnaliser -->
                                      @if (customizableItems[selectedItem.id]) {
                                        <div class="mt-1">
                                          <span
                                            (click)="openProductCustomization(selectedItem, selectedItem.componentId, index); $event.stopPropagation()"
                                            class="inline-flex items-center text-xs cursor-pointer hover:text-[#e66609] transition-colors underline"
                                            [class.text-[#888888]]="!hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)"
                                            [class.text-red-600]="hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)">
                                            @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) || hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                              <mat-icon
                                                class="material-symbols-outlined text-sm mr-1">
                                                {{ hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'warning' : '' }}
                                              </mat-icon>
                                            }
                                            {{ isItemCustomized(selectedItem.componentId, selectedItem.id, index) ?
                                            (hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index) ? 'Compléter' : 'Modifier') :
                                            'Personnaliser' }}
                                          </span>
                                        </div>
                                      }
                                    </div>
                                    <!-- Bouton Supprimer -->
                                    <mat-icon
                                      class="material-symbols-outlined icon cursor-pointer text-red-500 hover:text-red-700 transition-colors ml-2"
                                      (click)="removeItem(selectedItem.componentId, selectedItem.id)"
                                      title="Supprimer">
                                      delete
                                    </mat-icon>
                                  </div>
                                  <!-- Résumé personnalisation -->
                                  @if (isItemCustomized(selectedItem.componentId, selectedItem.id, index) && !hasIncompleteRequiredCustomizations(selectedItem.componentId, selectedItem.id, index)) {
                                    <div
                                      class="mt-2 ml-1 space-y-1">
                                      <div class=" rounded-md px-2 py-1.5 text-xs">
                                        <div class="text-gray-400 leading-relaxed">
                                          @for (line of getCustomizationSummary(selectedItem.componentId, selectedItem.id, index).split('\n'); track line) {
                                            <div
                                              >
                                              @if (line.startsWith('➕ Suppléments')) {
                                                <span>{{ line.split(':')[0] }} : </span>
                                                @for (part of line.split(':')[1].split('|||'); track part; let last = $last) {
                                                  @if (part.includes('[CAT]')) {
                                                    <span class="text-primary font-semibold">
                                                      {{ part.split('-')[0].replace('[CAT]', '').trim() }}
                                                    </span>
                                                    - {{ part.split('-').slice(1).join('-') }}
                                                  } @else {
                                                    {{ part }}
                                                  }
                                                  @if (!last) {
                                                    <span>, </span>
                                                  }
                                                }
                                              } @else {
                                                {{ line }}
                                              }
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                        <!-- Message si aucun article -->
                      </div>
                    </div>
                    <!-- Prix total (optionnel) -->
                    <div class="p-3 space-y-2">
                      @if (getSelectedItems().length > 0) {
                        <div>
                          <div class="flex justify-between items-center">
                            <span class="text-sm text-site">Prix de base</span>
                            <span class="text-sm font-semibold text-site">
                              {{ formatBundlePrice() }}
                            </span>
                          </div>
                          @if (getTotalCartPrice() > bundle.price || isRedeemMode) {
                          <div class="mt-2 space-y-1">
                            @if (getExtrasPrice() > 0) {
                          <div class="flex justify-between items-center text-xs text-gray-500">
                            <span>Suppléments</span>
                            <span class="text-green-600">+{{ getExtrasPrice().toFixed(2) }} €</span>
                          </div>
                          }
                          <div class="flex justify-between items-center pt-2 border-t border-gray-200">
                            <span class="text-base font-bold text-site">Total</span>
                            <span class="text-base font-bold text-site">
                          {{ formatBundleTotal() }}
                          </span>
                        </div>
                      </div>
                          }
                        </div>
                      }
                      <button
                      [matButton]="themeConfig.appearance.button.action"
              [disabled]="!canAddToCart() || isSubmitting()"
                  class="w-full py-2 "
                        id="add-to-cart-button"
                        (click)="addToCart()"

                        >
                        <span>Ajouter au panier</span>
                      </button>
                      @if (getSelectedItems().length === 0) {
                        <div
                          class="text-center text-gray-400 text-sm py-4">
                          Aucun article sélectionné
                        </div>
                      }
                      <!-- Message de validation général -->
                      @if (getValidationMessage() !== '') {
                        <div
                          class=" p-3 rounded-[6px]">
                          <div class="text-sm text-red-500 flex items-center">
                            <div>
                              <mat-icon class="material-symbols-outlined text-sm mr-1 text-[18px]">warning</mat-icon>
                            </div>
                            <span>
                              {{ getValidationMessage() }}
                            </span>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
